import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../../actions/';
import FormFiador from '../../components/fiadores/form-fiador';


const mapStateToProps = (state, ownProps) => {

    return { listFiadores: state.fiadores.listFiadores };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        removeItemArquivoFiador: (indice) => {
            dispatch(actions.removeItemArquivoFiador(indice));
        },

        onSaveFile: (origem, descricao, arquivoBytes, indice) => {
            dispatch(actions.saveItemArquivoFiador(descricao, arquivoBytes, indice));
        },
        onRemoveFiador(indice){
          
            dispatch(actions.onRemoveFiador(indice));
        },

        onAddFiador(){
            dispatch(actions.addFormFiador());
        },

        onConcluirEnvioFiadores() {
            console.log('onConcluirEnvioFiadores');
            dispatch(actions.onConcluirEnvioFiadores());
        }   
    };
};

const FormFiadorContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(FormFiador);


export default FormFiadorContainer;


// WEBPACK FOOTER //
// ./src/containers/fiadores/form-fiador.js